/*

Data for rendering links in the header and mobile navigation menu.

*/

import React from "react"
import { LogoutIcon } from "../components/atoms/icons/LogoutIcon"
import { CartIcon } from "../components/organisms/Header"

interface IconProps {
  fill: string
  cartNumber?: number
}

export type NavItem =
  | {
      title: string
      path: string
      hidden?: boolean
      icon?: React.FunctionComponent<IconProps>
      anchor?: boolean
    }
  | {
      title: string
      path: string
      hidden?: boolean
      icon?: React.FunctionComponent<IconProps>
      subMenu: NavItem[]
    }

export const ORGANIZATION_SUBMENU: NavItem[] = [
  { title: "Details", path: "/organization/details" },
  { title: "Members", path: "/organization/members" },
  { title: "Groups", path: "/organization/groups" },
  { title: "Activity log", path: "/organization/activity-log" },
  { title: "Receipts", path: "/organization/receipts" },
  { title: "Suborganizations", path: "/organization/suborganizations" },
  { title: "Terminals", path: "/organization/terminals" },
]

export const PROFILE_SUBMENU: NavItem[] = [
  { title: "Account", path: "/profile/account" },
  { title: "Notifications", path: "/profile/notifications" },
  { title: "Receipts", path: "/profile/receipts" },
]

export const HOME = { title: "Home", path: "/" }
export const STORE = { title: "Store", path: "/store" }
export const CASES = { title: "Cases", path: "/cases" }
export const DASHBOARD = { title: "Dashboard", path: "/dashboard" }
export const ORGANIZATION = { title: "Organization", path: "/organization" }
export const PROFILE = { title: "Profile", path: "/profile" }
export const ABOUT = { title: "About", path: "/about" }
export const APPLICATIONS = { title: "Applications", path: "/applications" }
export const CONTACT = { title: "Contact", path: "/contact" }
export const NEWS = { title: "News", path: "/news" }
export const LOGIN = { title: "Log in", path: "/login" }
export const LOGOUT = { title: "Log out", path: "/logout" }
export const CART = { title: "Cart", path: "/store/cart" }
export const PRODUCTS = { title: "Products", path: "/products" }

export const navItemsDesktop = (): NavItem[] => [STORE, PRODUCTS, APPLICATIONS, ABOUT]

export const navItemsDesktopLoggedIn = (userLoggedIn: boolean): NavItem[] => [
  { ...DASHBOARD, hidden: !userLoggedIn },
  { ...ORGANIZATION, hidden: !userLoggedIn },
]

export const navItemsMobile = (userLoggedIn: boolean): { beforeDivider: NavItem[]; afterDivider: NavItem[] } => ({
  beforeDivider: [
    HOME,
    STORE,
    PRODUCTS,
    APPLICATIONS,
    { ...CART, icon: CartIcon, anchor: true },
    { ...DASHBOARD, hidden: !userLoggedIn },
    { ...ORGANIZATION, subMenu: ORGANIZATION_SUBMENU, hidden: !userLoggedIn },
    { ...PROFILE, subMenu: PROFILE_SUBMENU, hidden: !userLoggedIn },
  ],
  afterDivider: [
    { ...LOGIN, hidden: userLoggedIn },
    { ...LOGOUT, hidden: !userLoggedIn, icon: LogoutIcon, anchor: true },
  ],
})
